import { render, staticRenderFns } from "./TramiteRecibido.vue?vue&type=template&id=005fa854&"
import script from "./TramiteRecibido.vue?vue&type=script&lang=js&"
export * from "./TramiteRecibido.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports